import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Clipboard } from "@angular/cdk/clipboard";
import { first } from "rxjs/operators";
import { ApiService } from "../api.service";
import { CategoryLan } from "../shared/models/CategoryLan";
import { CountryVO } from "../shared/models/CountryVO";
import { EmailsDocument } from "../shared/models/EmailsDocument";
import {
  ConfirmationService,
  MessageService,
} from "primeng/api";
import { AuthenticationService } from "../_services";
import { SecurityDocument } from "../shared/models/SecurityDocument";
import { TovpilLanguageService } from "../utils/tovpil-language.service";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "app-tovpil-emails-review",
  templateUrl: "./tovpil-emails-review.component.html",
  styleUrls: ["./tovpil-emails-review.component.scss"],
  providers: [MessageService, ConfirmationService],
})

export class TovpilEmailsReviewComponent implements OnInit {

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  lstEmails?: EmailsDocument[] = [];
  emailToUpdate?: EmailsDocument;
  selectedEmails?: string[] = [];
  clipBoardEmails?: string;
  language: string;
  lstCountrys: CountryVO[];
  lstStatus: CategoryLan[];
  mapTransCountrys = new Map();
  mapStatus = new Map();
  region?: string;
  clipBoardPressed?: boolean = false;
  totAccepted: number = 0;
  totRejected: number = 0;
  device: string;
  searchingEmail?: string;
  responsiveModal: boolean = false;
  notFoundedEmails: string = '';

  token: string;
  security: SecurityDocument;
  modalStatus: boolean = false;

  /** LABELS */
  translations: Record<string, string> = {};
  emailsForm: FormGroup;

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private translationService: TovpilLanguageService,
    private clipboard: Clipboard,
    private fb: FormBuilder
  ) {
    this.emailsForm = this.fb.group({
      email: new FormControl({ value: null, disabled: true }),
      country: new FormControl({ value: null, disabled: true }),
      status: new FormControl({ value: null }),
      type: new FormControl({ value: null }),
      acceptEmails: new FormControl({ value: null }),
    });
  }

  ngOnInit(): void {
    this.clipBoardPressed = false;
    this.route.queryParams.subscribe((params) => {
      this.token = params.token;
      this.device = params.device;

      if (this.token) {
        if (this.device && this.device == "O") {
          this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
        } else {
          this.getSecurity();
        }
      }
    });
  }

  copyText() {
    this.clipboard.copy(this.clipBoardEmails);
    this.messageService.add({
      severity: "success",
      summary: "Exito",
      detail: "Texto Copiado a portapapeles",
      life: 3000,
    });
  }

  async getSecurity() {
    let data = await this.apiService.findSecurityById({ id: this.token });
    this.security = data;
    this.getTranslatedLabels();
    this.getStatus();
    this.listTranslatedCountrys(this.security.language);
  }

  async listEmailsByStatus() {
    this.blocked = true; // OVERLAY LOADING 
    let lstEmailsTmp: EmailsDocument[];
    let ct: number;
    let data = await this.apiService.listEmailsByStatus({ status: "0" });
    lstEmailsTmp = data;
    for (let i = 0; i < lstEmailsTmp.length; i++) {
      lstEmailsTmp[i].status = "L";
    }
    await this.apiService.updateEmailList(
      JSON.parse(JSON.stringify(lstEmailsTmp))
    );
    /// load L status
    //read L Statut

    let data2 = await this.apiService.listEmailsByStatus({ status: "L" });
    lstEmailsTmp = data2;

    ct = 1;
    if (lstEmailsTmp != null) {
      this.lstEmails = lstEmailsTmp.concat(this.lstEmails);
    }
    this.clipBoardEmails = " ";
    this.lstEmails.forEach((element) => {
      this.clipBoardEmails = this.clipBoardEmails + element.email + ",";
    });
    this.assignContryName();
    this.blocked = false; // OVERLAY LOADING 
  }

  listTranslatedCountrys(language: string) {
    this.apiService.listTranslatedCountrys(language).then((data) => {
      this.lstCountrys = data;

      this.lstCountrys.forEach((element) => {
        if (element.descripTo != null) {
          this.mapTransCountrys.set(element.countryId, element.descripTo);
        } else {
          this.mapTransCountrys.set(element.countryId, element.descrip);
        }
      });

      this.listEmailsByStatus();
    });
  }

  getStatus() {
    this.apiService
      .getCategoryLang({
        language: this.security.language,
        fieldId: "emlVerSts",
      })
      .then((categs) => {
        this.lstStatus = categs;
        this.lstStatus.forEach((element) => {
          if (element.descripTo != null) {
            this.mapStatus.set(element.fieldVal, element.descripTo);
          } else {
            this.mapStatus.set(element.fieldVal, element.descrip);
          }
        });
      });
  }

  goBack() {
    this.confirmationService.confirm({
      message: this.translations.lbl_wish_to_continue + "?",
      header: this.translations.lbl_confirm + " " + this.translations.lbl_back,
      icon: "pi pi-exclamation-triangle",
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.clipBoardPressed = false;
        this.clipBoardEmails = " ";
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      },
    });
  }
  goAccept() {
    let lstEmailsAccepted: EmailsDocument[] = [];
    let lstEmailsRejected: EmailsDocument[] = [];
    let ct1: number;
    let ct2: number;
    this.confirmationService.confirm({
      message: this.translations.lbl_wish_to_continue + "?",
      header:
        this.translations.lbl_confirm + " " + this.translations.lbl_accept,
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: "pi pi-exclamation-triangle",

      accept: () => {
        ct1 = 0;
        ct2 = 0;
        for (let i = 0; i < this.lstEmails.length; i++) {
          if (this.lstEmails[i].status == "L") {
            lstEmailsAccepted[ct1] = this.lstEmails[i];
            lstEmailsAccepted[ct1].status = "A";
            ct1++;
          }
          if (this.lstEmails[i].status == "M") {
            lstEmailsRejected[ct2] = this.lstEmails[i];
            lstEmailsRejected[ct2].status = "X";
            ct2++;
          }
        }
        this.apiService
          .updateEmailList(JSON.parse(JSON.stringify(lstEmailsAccepted)))
          .then((data) => { });
        if (lstEmailsRejected != null) {
          this.apiService
            .updateEmailList(JSON.parse(JSON.stringify(lstEmailsRejected)))
            .then((data) => { });
        }

        this.lstEmails = [];
        this.clipBoardEmails = " ";
        this.totAccepted = 0;
        this.totRejected = 0;
        this.clipBoardPressed = false;
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      },
    });
  }
  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * `getLanguages`.
   */
  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(
        this.security.language,
        this.security.region
      );
      this.translations = this.translationService.getLabels();
      // await this.getLanguages();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      this.messageService.add({
        severity: "warn",
        summary: "Error",
        detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}`,
      });
      // Error al traer labels traducidos
    }
  }
  assignContryName() {
    if (this.lstEmails != null) {
      this.lstEmails.forEach((element) => { });
    }
  }
  checkValue(selEmail, val: any) {
    if (this.lstEmails != null) {
      for (let i = 0; i < this.lstEmails.length; i++) {
        if (selEmail == this.lstEmails[i].email)
          if (this.lstEmails[i].status == "L") {
            this.lstEmails[i].status = "M";
          } else {
            this.lstEmails[i].status = "L";
          }
      }
    }
  }
  goClipBoard() {
    if (this.lstEmails != null && this.lstEmails.length > 0) {
      this.clipBoardPressed = true;

      if (this.selectedEmails != null) {
        this.totRejected = this.selectedEmails.length;
      } else {
        this.totRejected = 0;
      }
      this.totAccepted = this.lstEmails.length - this.totRejected;
    }
  }
  checDisaled() {
    return this.clipBoardPressed;
  }
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
          }
        },
        (error) => { }
      );
  }

  closeModal() {
    this.modalStatus = false;
    this.emailsForm.patchValue({
      email: null,
      country: null,
      status: null,
      type: null,
      acceptEmails: null,
    });
  }

  async updateStatus() {
    let email: EmailsDocument = {
      email: this.emailsForm.get("email").value ?? null,
      status: this.emailsForm.get("status").value.fieldVal ?? null,
      acceptEmails: this.emailsForm.get("acceptEmails").value ?? null,
      country: this.emailsForm.get("country").value ?? null,
      type: this.emailsForm.get("type").value ?? null,
    };

    // aanacristins@gmail.com
    let data = await this.apiService.updateEmails(email);
    const index = this.lstEmails.findIndex(
      (element) => element.email === data.email
    );

    this.lstEmails[index] = data;

    this.closeModal();
    this.searchingEmail = "";
  }


  //This function search for emails in the database and puts them at the bottom of table
  async addEmailsToTable() {
    let data: EmailsDocument[];
    let isOnTable;
    let notFounded: string[];
    this.notFoundedEmails = '';

    //Validates the input is not empty
    if (this.searchingEmail != "" && this.searchingEmail != null) {
      //Puts all the emails in an array
      let emails = this.searchingEmail.split(",");
      // Looks for every email on the actual table and checks if exist or not inside the table
      for (let i = 0; i < emails.length; i++) {
        emails[i] = emails[i].trim();
        isOnTable = this.lstEmails.some((element) => element.email === emails[i]);
        if (isOnTable) {
          this.messageService.add({ severity: "warn", summary: "Inválido", detail: `El email ${emails[i]} ya existe en la tabla`, life: 3000, });
          return;
        }
      }
      //If all emails are not in the table looks for them in th database and lists them at the bottom
      if (!isOnTable) {
        try {
          data = await this.apiService.listByEmails(
            JSON.parse(JSON.stringify(emails))
          );
          if (data.length === 0) {
            this.messageService.add({ severity: "warn", summary: "Inválido", detail: `No se encontro ninguna coincidencia`, life: 3000, });
            return;
          }
        } catch (error) {
          console.error(error);
        }

        this.lstEmails = this.lstEmails.concat(data);
        for (let i = 0; i < emails.length; i++) {
          isOnTable = this.lstEmails.some((element) => element.email === emails[i]);
          if (!isOnTable) {
            if (this.notFoundedEmails.length === 0) {
              this.notFoundedEmails += emails[i];
            }
            else {
              this.notFoundedEmails += ', ' + emails[i];
            }
          }
        }

        this.searchingEmail = '';
        if (this.notFoundedEmails.length > 0) {
          this.responsiveModal = true;
        }
      }
    }
    else {
      this.messageService.add({
        severity: "warn",
        summary: "Inválido",
        detail: `Ingresa algun correo para buscar`,
        life: 3000,
      });
    }
  }

  async getEmailModal(value) {
    try {
      let email = value.email;
      let data = await this.apiService.getEmailsCtlById(email);

      let retrievedStatus = this.lstStatus.filter(
        (e) => e.fieldVal === data.status
      );

      this.emailsForm.patchValue({
        email: data.email,
        country: data.country,
        status: retrievedStatus[0] ?? this.lstStatus[0],
        type: data.type,
        acceptEmails: data.acceptEmails,
      });
      this.modalStatus = true;
    } catch (e) {
      this.messageService.add({
        severity: "warn",
        summary: "Inválido",
        detail: "Email no encontrado",
        life: 3000,
      });
      this.closeModal();
    }
  }
}
